import script from "./MenuLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLayout.vue?vue&type=script&setup=true&lang=js"

import "./MenuLayout.vue?vue&type=style&index=0&id=831f3b44&lang=scss"

const __exports__ = script;

export default __exports__